module.exports = {
	"base": {
		"welcome": "歡迎使用 Mulligans，%{name}!",
		"user": "使用者資訊",
		"devices": "裝置",
		"refunds": "退貨",
		"resources": "資源",
		"transactions": "訂單與退貨",
		"email": "電子郵件",
		"password": "密碼",
		"save": "儲存",
		"sign-out": "登出",
		"cancel": "取消",
		"close": "關閉",
		"learn-more": "深入瞭解",
		"required": "必要項目",
		"support": "支援",
		"bookshelf": "書架",
		"launch": "啟用",
		"download": "下載",
		"details": "詳細資料",
		"cannot-be-blank": "%{field} 不可空白。",
		"saving": "正在儲存…",
		"done": "完成",
		"failed": "失敗",
		"copy": "複製"
	},
	"signin": {
		"login-failure": "電子郵件或密碼不正確",
		"welcome-large": "歡迎使用 <span class='inner'>%{brand} 帳戶中心</span>",
		"welcome-small": "<span class='inner'>帳戶中心</span>",
		"signin-button": "登入",
		"forgot-password": "忘記您的密碼",
		"new-to-vst": "才剛開始使用 %{brand}?",
		"create-account": "建立帳戶",
		"signing-in": "正在登入... ",
		"signin-failed": "登入失敗"
	},
	"transactions": {
		"price": "價格",
		"excluded": "(不含稅)",
		"quantity": "數量",
		"confirmation#": "確認號碼",
		"payment": "付款",
		"purchased": "已購買",
		"purchase-details": "購買詳細資料",
		"subtotal": "小計",
		"total": "總計",
		"tax": "稅款",
		"loading": "哈囉大買家，我們正在載入您的交易...",
		"no-purchases": "您沒有任何購買項目。",
		"seller-vat": "賣家增值稅",
		"total-vat": "已付 %{vat} 總計",
		"portion": "%{subTax}稅 %{rate}%",
		"vat-disclosure": "價格包含%{vat}",
		"purchases": "購買",
		"refunded-items": "退款項目",
		"book-title": "書籍標題",
		"refund-details": "退貨詳細資料",
		"print-receipt": "列印收據",
		"request-refund": "要求退款",
		"expired": "已過期",
		"expires-in": "到期日 %{date}",
		"details-refund": "詳細資料與退款",
		"modal": {
			"cant-refund-title": "不可退貨",
			"cant-refund": "由於下列一或多個原因，因此您的書籍無法退貨。",
			"cant-refund-1": "已檢視太多書籍內容。",
			"cant-refund-2": "自購買日起已超過 14 天。",
			"cant-refund-3": "您的線上資源代碼已開啟。",
			"cant-refund-4": "您的書籍先前已退貨。",
			"cant-refund-5": "所有代碼皆已兌換和/或退貨。",
			"cant-refund-6": "自購買日起已超過 30 天。",
			"cant-refund-support": "若您仍不了解 %{brand} 的退貨政策，請連絡<a href='%{support_url}' target='_blank'>技術支援中心</a>。"
		},
		"license": {
			"perpetual": "線上存取尚未過期",
			"days": "%{days} 天存取期"
		}
	},
	"devices": {
		"description": "%{brand} 可讓您隨時啟用 <span>%{desktop}</span> 台電腦和 <span>%{mobile}</span> 台行動/平板裝置。",
		"loading": "哈囉，我們正在連結您的裝置 :)",
		"no-active": "您沒有可用的裝置。",
		"deactivate": "停用"
	},
	"user": {
		"personal-information": "個人資訊",
		"security-information": "安全性資訊",
		"notifications": "通知",
		"first-name": "名字",
		"last-name": "姓氏",
		"change-password-title": "變更密碼",
		"current-password": "目前密碼",
		"new-password": "新密碼",
		"security-password": "密碼",
		"confirm-new-password": "確認新密碼",
		"security-question": "安全性問題",
		"security-info-change": "變更",
		"question": "問題",
		"answer": "答案",
		"notifications-text": "以電子郵件通知我關於帳戶的活動、產品更新及特別優惠。",
		"loading": "小花已經出去找尋您的使用者資訊，請稍等 🐶",
		"change-password-text": "密碼必須包含至少 8 個字元，其中一個大寫字母、一個小寫字母和一個特殊字元。 ",
		"email-locked": "電子郵件已鎖定",
		"email-locked-description": "您沒有變更個人電子郵件的權限。",
		"email-locked-more": "請連絡您的系統管理員",
		"security-question6": "您最喜歡什麼運動?",
		"security-question7": "您最喜歡什麼口味的冰淇淋?",
		"security-question8": "您最喜歡的寵物名字是?",
		"security-question9": "您小時候希望長大後成為?",
		"security-question10": "您最喜歡的老師姓氏是?",
		"new-password-failure": "密碼不符合要求",
		"confirm-password-failure": "密碼必須相符",
		"new-password-tooltip": "必須包含至少 8 個字元，其中一個大寫字母、一個小寫字母和一個特殊字元。",
		"enter-valid-email": "請輸入有效的電子郵件。",
		"password-cannot-be-same": "密碼不可與先前的密碼相同",
		"incorrect-password": "密碼不正確",
		"complete-account": "您似乎需要<a href='%{href}'>完成填寫帳戶資料</a>。",
		"completing-allows": "完成填寫帳戶資料後，您就可以使用行動應用程式離線閱讀書籍，以及與朋友分享附註和醒目提示。",
		"error-updating-info": "There was an error updating your information.",
		"password-updated": "Password successfully updated",
		"security-updated": "Security question successfully updated",
		"info-updated": "User information successfully updated"
	},
	"resources": {
		"ancillaries": "附屬品",
		"access-codes": "存取代碼",
		"print-on-demand": "隨選列印",
		"check-pod": "查看您書籍的出版商印刷選項。",
		"check-now": "立即查看",
		"loading": "跟緊囉，我們正在更新您的資源!",
		"in": "位於",
		"access-code-intro": "存取代碼為您用於存取線上課程內容的密碼。一旦您開啟某個項目的代碼，便無法改回。若需要更多關於如何使用您的存取代碼之指引，請造訪 <a href='%{support_url}' target='_blank'>支援頁面</a>。",
		"expires": "過期",
		"expiration-message": "包含使用存取代碼之指引。",
		"copy-fail": "無法複製。請選取代碼並手動複製。",
		"launch-site": "啟用網站",
		"launch-book": "啟用書籍",
		"reveal-code": "顯示代碼",
		"no-resources": "您沒有任何資源。",
		"no-access-codes": "您沒有任何存取代碼。",
		"no-ancillaries": "無此標題的附屬品",
		"name": "名稱",
		"type": "類型",
		"size": "大小",
		"download-all": "下載全部",
		"back": "返回資源"
	},
	"refunds": {
		"states": {
			"refunded": "已退貨",
			"unavailable": "不可退貨"
		},
		"reasons": {
			"dropped": "我已退選課程",
			"wrong": "這不是我課程使用的書籍",
			"print": "我決定要另外購買印刷版本",
			"missing": "這本書籍不包含課程所需的所有項目 (例如：CD、網路存取、影片)",
			"other": "其他"
		},
		"bulk": {
			"policy": "按下下方的「完整退貨」按鈕，即表示我同意 %{brand} 的 <a href='%{policy_url}' target='_blank'>退貨政策</a>。",
			"complete": "完整退貨",
			"view-details": "檢視退貨詳細資料",
			"success": "您已要求退款。請等待 48 小時完成處理。",
			"failure": "糟糕 - 發生問題!很遺憾您的退貨並未成功。",
			"retry": "再試一次",
			"support": "連絡技術支援中心",
			"available-codes": "可用代碼",
			"codes-selected": "已選取代碼",
			"download": "下載代碼",
			"partially-refunded": "部分退貨",
			"pick-one": "您必須選取至少一個代碼以進行退貨"
		},
		"refund": "退貨",
		"all": "全部退貨嗎?",
		"missing-reason": "您必須選取一個原因以繼續",
		"missing-elaboration": "請說明",
		"policy": "按一下下方的「完成退貨要求」按鈕，即表示我了解若我再次購買此本 %{brand} 電子課本，我將不符合再次要求此本相同電子課本的退貨資格。 檢視完整的退貨政策。",
		"refunded": "已退貨",
		"sorry": "無法滿足您的購買需求，我們深感抱歉。",
		"error": "發生問題",
		"error-explain": "我們無法處理您的退貨要求。請再試一次。",
		"why": "請告訴我們原因。",
		"no-refunds": "您沒有已退貨的項目。",
		"select-codes": "選取代碼以進行退貨:",
		"number": "有多少項?",
		"back": "返回退款"
	},
	"purchases": {
		"back": "返回購買"
	},
	"global-bar": {
		"account": "帳戶設定"
	}
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/locales/zh-TW.json
 ** module id = 1028
 ** module chunks = 0
 **/